import script from "./ChatControl.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatControl.vue?vue&type=script&setup=true&lang=js"

import "./ChatControl.vue?vue&type=style&index=0&id=51ee5fc6&lang=scss"

const __exports__ = script;

export default __exports__